export const historyUnlockStorageKey = "clipstack.webHistoryUnlock.v1";
export const defaultHistoryUnlockMinutes = 60;

// The saved key is bound to the account that unlocked it, so a later account
// signed in on the same tab can never reuse it.
export function saveHistoryUnlockSession(storage, userId, recoveryKey, durationMinutes, now = Date.now()) {
  if (!userId) throw new Error("History unlock needs a loaded account.");
  const minutes = [15, 60, 240].includes(Number(durationMinutes))
    ? Number(durationMinutes)
    : defaultHistoryUnlockMinutes;
  const expiresAt = now + minutes * 60_000;
  storage.setItem(historyUnlockStorageKey, JSON.stringify({ userId: String(userId), recoveryKey: String(recoveryKey).trim(), expiresAt }));
  return expiresAt;
}

export function readHistoryUnlockSession(storage, userId, now = Date.now()) {
  try {
    const saved = JSON.parse(storage.getItem(historyUnlockStorageKey) || "null");
    if (!saved?.recoveryKey || !userId || saved.userId !== String(userId) || !Number.isFinite(Number(saved.expiresAt)) || Number(saved.expiresAt) <= now) {
      storage.removeItem(historyUnlockStorageKey);
      return null;
    }
    return { recoveryKey: String(saved.recoveryKey), expiresAt: Number(saved.expiresAt) };
  } catch {
    storage.removeItem(historyUnlockStorageKey);
    return null;
  }
}

export function clearHistoryUnlockSession(storage) {
  storage.removeItem(historyUnlockStorageKey);
}

export function formatHistoryUnlockRemaining(expiresAt, now = Date.now()) {
  const remainingSeconds = Math.max(0, Math.ceil((Number(expiresAt) - now) / 1000));
  const hours = Math.floor(remainingSeconds / 3600);
  const minutes = Math.floor((remainingSeconds % 3600) / 60);
  const seconds = remainingSeconds % 60;
  return hours
    ? `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
    : `${minutes}:${String(seconds).padStart(2, "0")}`;
}
